import "../style/footer.css"

export function Footer() {
    return (
        <div className="PMBP">
            <div className="FooterWrapper">
                <div className="site-footer">
                    <p className="footer_top"> Questions? Call (+33) 0805-543-064</p>
                    <ul className="footer_link_structural">
                        <li className="Footerlinkitem">
                            <a className="footerlink" href="https://help.netflix.com/support/412"><span>FAQ</span></a>
                        </li>
                        <li className="Footerlinkitem">
                            <a className="footerlink" href="https://help.netflix.com"><span >Help Center</span></a>
                        </li>
                        <li className="Footerlinkitem" >
                            <a className="footerlink" href="/youraccount"><span>Account</span></a>
                        </li>
                        <li className="Footerlinkitem" >
                            <a className="footerlink" data-uia="footerlink" href="https://media.netflix.com/"><span >Media Center</span></a>
                        </li>
                        <li className="Footerlinkitem" >
                            <a className="footerlink" href="http://ir.netflix.com/" ><span>Investor Relations</span></a>
                        </li>
                        <li className="Footerlinkitem">
                            <a className="footerlink" href="https://jobs.netflix.com/jobs"><span>Jobs</span></a>
                        </li>
                        <li className="Footerlinkitem" >
                            <a className="footerlink" href="/gift-cards"><span>Redeem Gift Cards</span></a>
                        </li>
                        <li className="Footerlinkitem" >
                            <a className="footerlink" href="/gift-cards"><span>Buy Gift Cards</span></a>
                        </li>
                        <li className="Footerlinkitem">
                            <a className="footerlink" href="/watch"><span>Ways to Watch</span></a>
                        </li>
                        <li className="Footerlinkitem">
                            <a className="footerlink" href="https://help.netflix.com/legal/termsofuse"><span >Terms of Use</span></a>
                        </li>
                        <li className="Footerlinkitem" >
                            <a className="footerlink" href="https://help.netflix.com/legal/privacy"><span>Privacy</span></a>
                        </li>
                        <li className="Footerlinkitem" >
                            <a className="footerlink" href="#"  ><span>Cookie Preference</span></a>
                        </li>
                        <li className="Footerlinkitem">
                            <a className="footerlink" href="https://help.netflix.com/legal/corpinfo"><span>Corporate Information</span></a>
                        </li>
                        <li className="Footerlinkitem">
                            <a className="footerlink" href="https://help.netflix.com/contactus"><span>Contact Us</span></a>
                        </li>
                        <li className="Footerlinkitem" >
                            <a className="footerlink" href="https://fast.com"><span >Speed Test</span></a>
                        </li>
                        <li className="Footerlinkitem" >
                            <a className="footerlink" href="https://netflix.com/legal/guarantee"><span>Legal Guarantees</span></a>
                        </li>
                        <li className="Footerlinkitem" >
                            <a className="footerlink" href="https://netflix.com/legal/guarantee"><span>Legal Notices</span></a>
                        </li>
                        <li className="Footerlinkitem">
                            <a className="footerlink" href="https://www.netflix.com/fr-en/browse/genre/839338"><span>Only on Netflix</span></a>
                        </li>
                    </ul>
                    <p className="footer_country" >Netflix English</p>
                </div>
            </div>
        </div>
    )
}